// Load only icons we need https://github.com/FortAwesome/vue-fontawesome
import {config, library} from '@fortawesome/fontawesome-svg-core'

// https://stackoverflow.com/a/58913667/26192
config.autoAddCss = false

// These next lines help during development, but we should never deploy with all icons bundled.
// import {fas} from '@fortawesome/free-solid-svg-icons';
// import {far} from '@fortawesome/free-regular-svg-icons';
// import {fab} from '@fortawesome/free-brands-svg-icons';
// library.add(fas, far, fab);

library.add(
  require('@fortawesome/free-regular-svg-icons/faCircle').definition,
  require('@fortawesome/free-regular-svg-icons/faCirclePlay').definition,
  require('@fortawesome/free-regular-svg-icons/faClock').definition,
  require('@fortawesome/free-regular-svg-icons/faStickyNote').definition,
  require('@fortawesome/free-solid-svg-icons/faArrowCircleRight').definition,
  require('@fortawesome/free-solid-svg-icons/faBatteryEmpty').definition,
  require('@fortawesome/free-solid-svg-icons/faBatteryFull').definition,
  require('@fortawesome/free-solid-svg-icons/faBatteryHalf').definition,
  require('@fortawesome/free-solid-svg-icons/faBatteryQuarter').definition,
  require('@fortawesome/free-solid-svg-icons/faBatteryThreeQuarters').definition,
  require('@fortawesome/free-solid-svg-icons/faCheck').definition,
  require('@fortawesome/free-solid-svg-icons/faCheckCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronLeft').definition,
  require('@fortawesome/free-solid-svg-icons/faChevronRight').definition,
  require('@fortawesome/free-solid-svg-icons/faCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faCloud').definition,
  require('@fortawesome/free-solid-svg-icons/faDoorOpen').definition,
  require('@fortawesome/free-solid-svg-icons/faEllipsisV').definition,
  require('@fortawesome/free-solid-svg-icons/faEnvelope').definition,
  require('@fortawesome/free-solid-svg-icons/faExclamationCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faExclamationTriangle').definition,
  require('@fortawesome/free-solid-svg-icons/faExternalLinkAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faEye').definition,
  require('@fortawesome/free-solid-svg-icons/faFilter').definition,
  require('@fortawesome/free-solid-svg-icons/faHashtag').definition,
  require('@fortawesome/free-solid-svg-icons/faInfoCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faLightbulb').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarker').definition,
  require('@fortawesome/free-solid-svg-icons/faMapMarkerAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faPhone').definition,
  require('@fortawesome/free-solid-svg-icons/faPhoneAlt').definition,
  require('@fortawesome/free-solid-svg-icons/faPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faPlusCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faRedo').definition,
  require('@fortawesome/free-solid-svg-icons/faShippingFast').definition,
  require('@fortawesome/free-solid-svg-icons/faSignal').definition,
  require('@fortawesome/free-solid-svg-icons/faThermometerHalf').definition,
  require('@fortawesome/free-solid-svg-icons/faThermometerHalf').definition,
  require('@fortawesome/free-solid-svg-icons/faTimes').definition,
  require('@fortawesome/free-solid-svg-icons/faToggleOff').definition,
  require('@fortawesome/free-solid-svg-icons/faToggleOn').definition,
  require('@fortawesome/free-solid-svg-icons/faUserCircle').definition,
  require('@fortawesome/free-solid-svg-icons/faUserPlus').definition,
  require('@fortawesome/free-solid-svg-icons/faWifi').definition,
)
